import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import { formatMinutes } from "../../../../utils/time";
import { C } from "../../../utils";

import S from "./PathDetails.module.scss";

interface PathDetailsProps {
  title: string;
  description: string;
  enrolledInPath: boolean;
  pointsEarned: number;
  totalPoints: number;
  lessonsCompleted: number;
  lessonsInPath: number;
  estimatedTimeRemaining: number;
  canInteract?: boolean;
}

export const PathDetails = ({
  title,
  description,
  enrolledInPath,
  pointsEarned,
  totalPoints,
  lessonsCompleted,
  lessonsInPath,
  estimatedTimeRemaining,
  canInteract = true,
}: PathDetailsProps) => {
  const handleEnrollClick = () => {
    // SHRPA-2506 -- build out enroll/unenroll functionality
    if (enrolledInPath) {
      console.log("Unenroll from path");
    } else {
      console.log("Enroll in path");
    }
  };

  return (
    <div className={C(S.pathDetailsContainer, "pb-8")}>
      <div className={S.pathDetailsHeader}>
        <div className={S.pointsContainer}>
          <Tag value="PATH" severity="secondary" rounded={true} />
          {totalPoints > 0 && <h5 className={C(S.mutedText, "atlas-h5")}> +{totalPoints}</h5>}
        </div>
        {/* TODO: different variants based on enrollment status */}
        <Button
          label={enrolledInPath ? "Unenroll from Path" : "Enroll in Path"}
          severity={enrolledInPath ? "secondary" : undefined}
          onClick={handleEnrollClick}
          disabled={!canInteract}
        />
      </div>

      <h3 className={C("atlas-h2-alt", "leading-tight")}>{title}</h3>
      <p className="body-lg">{description}</p>

      <div className={S.pathProgressContainer}>
        <div className={S.section}>
          <h3 className={C(S.mutedText, "atlas-h5 uppercase")}>Points Earned</h3>
          <p className="atlas-h2">{pointsEarned}</p>
          <p className={S.mutedText}>/ {totalPoints} available</p>
        </div>

        <div className={S.section}>
          <h3 className={C(S.mutedText, "atlas-h5 uppercase")}>Lessons Completed</h3>
          <p className="atlas-h2">{lessonsCompleted}</p>
          <p className={S.mutedText}>/ {lessonsInPath} total lessons</p>
        </div>

        <div className={S.section}>
          <h3 className={C(S.mutedText, "atlas-h5 uppercase")}>Est Time Remaining</h3>
          <p className="atlas-h2">{formatMinutes(estimatedTimeRemaining)}</p>
        </div>
      </div>
    </div>
  );
};
